import { css } from 'styled-components';

export default css`
  .icon {
    display: inline-block;
    fill: currentColor;
    height: 1em;
    width: 1em;

    &--small {
      height: 0.6em;
      width: 0.6em;
    }

    &--large {
      height: 1.25em;
      width: 1.25em;
    }

    &--larger {
      height: 1.5em;
      width: 1.5em;
    }

    &--largest {
      height: 2em;
      width: 2em;
    }
  }
`;
